export const APP_BACKEND_FUNCTION_NAME = 'portfolio-app_backend' as string;
export const APP_BACKEND_URL = 'https://portfolio.matthis.link/' as string;
export const APP_BACKEND_ROLE_ARN =
  'arn:aws:iam::982619301361:role/portfolio-app_backend-role' as string;
export const APP_FRONTEND_CLOUDFRONT_DOMAIN_NAME = 'static.portfolio.matthis.link' as string;
export const CURRENT_ENV = '982619301361' as string;
export const REGION = 'eu-west-3' as string;
export const ACCOUNT_ID = '982619301361' as string;
export const CODE_BUCKET = 'portfolio-code-20250202140935577100000002' as string;
